/**
 * Copyright 2026 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */

// Auto-generated from 2nd-gen/packages/core/package.json
// Generation: 2nd-gen
// DO NOT EDIT - This file is generated by scripts/generate-versions.js

/**
 * The version of the 2nd-gen Spectrum Web Components library.
 */
export const version = '2.0.0-beta.2';

/**
 * The version of the core base package.
 */
export const coreVersion = '2.0.0-beta.2';
